export const report = {
	title: "Informes",
	templateTitle: "Informe General",
	search: "Buscar",
	tabs: {
		general: {
			title: "Vista general",
			cards: {
				promoters: "Promotores",
				relationLists: "Listas",
				guests: "Invitados",
				entranceTotal: "Total en entrada",
				consumptionTotal: "Total en consumo",
				total: "Total general",
			},
			columns: {
				listName: "Lista",
				guestName: "Nombre",
				cpf: "RFC",
				promoter: "Promotor",
				entrance: "Tipo de entrada",
				upgradeEntrance: "Upgrade de entrada",
				consumption: "Consumo",
				generalTotal: "Total general",
				checkin: "Detalles del check-in",
				phone: "Teléfono",
				birthDate: "Fecha de nacimiento",
			},
		},
		byList: {
			title: "Por lista de invitados",
			columns: {
				relationLists: "Listas",
				promoters: "Promotores",
				guests: "Invitados",
				entranceTotal: "Total en entrada",
				consumptionTotal: "Total en consumo",
				total: "Total general",
			},
		},
	},
	filters: {
		promoter: {
			title: "Filtrar por promotor",
			placeholder: "Agregar filtro por promotores",
		},
		relation: {
			title: "Filtrar por lista de invitados",
			placeholder: "Agregar filtros por lista",
		},
		period: "Período",
	},
	empty: {
		search: "No encontramos resultado para su búsqueda",
		filters: {
			title: "No encontramos resultado para esta selección",
			subtitle: "Seleccione otra opción e intente nuevamente",
		},
		noneList: {
			title: "Parece que aún no ha creado una lista",
			subtitle: "Los informes aparecerán aquí cuando tenga una lista registrada",
		},
	},
	file: {
		filename: "informe-lista-de-invitados",
		titleByGuestList: "Informe por lista de invitados",
		titleGeneral: "Informe general",
		listName: "Nombre de la Lista",
		promoter: "Promotor",
		numberOfActiveGuests: "Check-in realizados",
		numberOfGuests: "Total de invitados",
		entranceTotal: "Total de entrada",
		consumptionTotal: "Total en consumo",
		total: "Total general",
		name: "Nombre",
		document: "RFC",
		entranceType: "Tipo de entrada",
		upgrade: "Upgrade de entrada",
		checkinDetails: "Detalles del check-in",
		phone: "Teléfono",
		birthDate: "Fecha de nacimiento",
	},
};
